import { useEffect, useState } from 'react';
import { getWhatsAppUnreadCount } from '../lib/api';

const POLL_MS = 60000;

export const useWhatsAppUnread = (enabled) => {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    const load = () => getWhatsAppUnreadCount()
      .then((r) => { if (active) setUnread(r.data.unread || 0); })
      .catch(() => {});
    load();
    const id = setInterval(load, POLL_MS);
    window.addEventListener('whatsapp-inbox-updated', load);
    return () => {
      active = false;
      clearInterval(id);
      window.removeEventListener('whatsapp-inbox-updated', load);
    };
  }, [enabled]);

  return unread;
};
